// extracted by mini-css-extract-plugin
module.exports = {"background":"styles-module--background--3CcZc","darkBg":"styles-module--darkBg---VBdT","sticky":"styles-module--sticky--145GE"};